import styled from 'styled-components';
import styledProps from 'styled-props/lib/styledProps';
import { Box } from 'rebass';

const profileDefinitions = {
	small: {
		heightWidth: '48px'
	},
	large: {
		heightWidth: '88px'
	}
}

const profileWidthHeights = {
	small: profileDefinitions.small.heightWidth,
	large: profileDefinitions.large.heightWidth
}

export default styled.div`
	height: ${styledProps(profileWidthHeights)};
	width: ${styledProps(profileWidthHeights)};
	border-radius: 50%;
	background: url('${props => props.backgroundImg}') no-repeat center;
	background-size: cover;
`


// WEBPACK FOOTER //
// ./src/components_new/common/ProfileImg.js